// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetPreviewWrapper_container__3jeA4","box":"WidgetPreviewWrapper_box__3w7Sm"};